import * as z from 'zod';

import { booleanMutationSchema, nullableNumericMutationSchema } from '@/_schemas/generic';
import { statusMutationSchema } from '@/_schemas/status-input';

import { inventoryQuerySchema } from './inventory-query-schema';

import { skusLinkerMutationSchema } from '../skus';

export const inventoryUpdateSchema = inventoryQuerySchema
  .omit({
    primary_sku: true,
    images: true,
    inventory_category: true,
    inventory_volume: true,
    vendors: true,
    bin_locations: true,
    brand: true,
    children: true,
  })
  .extend({
    status: statusMutationSchema,
    images: z.array(z.number()),
    category_id: z.number().nullable(),
    inventory_volume_id: z.number().nullable(),

    weight: nullableNumericMutationSchema(),
    last_order_cost: nullableNumericMutationSchema(),

    committed: nullableNumericMutationSchema(),
    current_stock: nullableNumericMutationSchema(),
    minimum_stock: nullableNumericMutationSchema(),
    maximum_stock: nullableNumericMutationSchema(),

    units_per_order: nullableNumericMutationSchema(),
    minimum_order: nullableNumericMutationSchema(),

    vendors: z.array(z.object({ vendor_id: z.number(), type: z.string() })),
    bin_locations: z.array(z.object({ bin_location_id: z.number() })),

    track_serial_numbers: booleanMutationSchema(),
    track_stock_quantities: booleanMutationSchema(),
    discontinued: booleanMutationSchema(),

    logo: z.array(z.number()),

    secondary_skus: skusLinkerMutationSchema,
    children: z.array(z.object({ inventory_id: z.number(), sort_order: z.number() })),
    vendor_details: z.array(z.number()),
  });

export type InventoryUpdateSchema = z.infer<typeof inventoryUpdateSchema>;

export const inventoryCreateSchema = inventoryUpdateSchema.omit({ id: true, images: true });

export type InventoryCreateSchema = z.infer<typeof inventoryCreateSchema>;
